import styled from 'styled';
import { space } from 'helpers/style';

export const QueryPanelContainer = styled.section`
  
  background-color: white;
  padding: ${space(2)};
  padding-bottom: 0;

  
  form {
    display: grid;
    grid-gap: ${space(2)};
    grid-template-columns: auto 1fr;
    grid-template-rows: auto auto 1fr;
    align-items: end;
    
    label {
      font-weight: ${({ theme }) => theme.font.weight.bold};
    }

    button[type="submit"] {
      width: fit-content;
      justify-self: end;
    }

    .dayPicker {
      grid-column: 1;
      grid-row: 1/-1;
    }

    .DayPicker.dayPicker {
      background: #fff !important;  
    }

    .DayPicker-Day--selected:not(.DayPicker-Day--start):not(.DayPicker-Day--end):not(.DayPicker-Day--outside) {
      background-color: #f0f8ff !important;
      color: #4a90e2;
    }
    .DayPicker-Day {
      border-radius: 0 !important;
    }
    .DayPicker-Months {
      justify-content: start !important;
    }
    .DayPicker-Month {
      margin-left: 0 !important;
    }
    .DayPicker-Day--start {
      border-top-left-radius: 50% !important;
      border-bottom-left-radius: 50% !important;
    }
    .DayPicker-Day--end {
      border-top-right-radius: 50% !important;
      border-bottom-right-radius: 50% !important;
    }
  }
`;